<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <check-fnwallet v-if="!hasPacket"></check-fnwallet>
        <futurocoins-from-mining v-if="hasPacket"></futurocoins-from-mining>
        <calculator></calculator>
    </b-col>
</template>

<script>
    import CheckFnwallet from './dashboard/CheckFnwallet.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    import Calculator from './calculator/Calculator.vue';

    export default {
        components: { CheckFnwallet, FuturocoinsFromMining, Calculator },
        computed: {
            hasPacket () {
                return this.$store.getters.user.position != 0
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/CalculatorContent.vue